import { useContext } from 'react';
import { Context } from './contexts';

export const useFlatsTableData = () => useContext(Context);
